var ADD_TOAST = "ADD_TOAST";
var CLEAR_TOASTS = "CLEAR_TOASTS";
var REMOVE_TOAST = "REMOVE_TOAST";
var RESET_TOASTS = "RESET_TOASTS";

export { ADD_TOAST, CLEAR_TOASTS, REMOVE_TOAST, RESET_TOASTS };
